/**
 * Validates if a string is a valid email address format
 * @param emailAddress - The email address string to validate
 * @returns true if the email format is valid, false otherwise
 */
export const isValidEmailAddress = (emailAddress: string | null | undefined): boolean => {
  // Return false for null, undefined, or empty strings
  if (!emailAddress || typeof emailAddress !== "string") {
    return false;
  }

  // Trim whitespace
  const trimmed = emailAddress.trim();

  // Basic email regex pattern
  // Matches: local-part@domain
  // local-part: can contain letters, numbers, dots, hyphens, underscores, plus signs
  // domain: must contain at least one dot, letters, numbers, hyphens
  const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(trimmed);
};

